import 'react-app-polyfill/ie9' // For IE 9-11 support
import 'react-app-polyfill/ie11' // For IE 11 support
import './polyfill'
import './App.scss'
import ReactDOM from 'react-dom'
import { Amplify } from 'aws-amplify'
import { Provider } from 'react-redux'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import App from './App'
import keys from './config/keys'
import configureStore from './store/configure-store'

const store = configureStore()
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

Amplify.configure({
  Auth: {
    mandatorySignIn: false,
    region: keys.cognito.REGION,
    userPoolId: keys.cognito.USER_POOL_ID,
    identityPoolId: keys.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: keys.cognito.APP_CLIENT_ID,
    identityPoolRegion: keys.cognito.REGION,
    oauth: {
      domain: process.env.REACT_APP_REDIRECT_DOMAIN_NAME,
      redirectSignIn: `${process.env.REACT_APP_HOST_PATH}/callback`,
      redirectSignOut: `${process.env.REACT_APP_HOST_PATH}/login`,
      responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
      scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  Analytics: {
    disabled: true,
  },
  Storage: {
    region: keys.s3.REGION,
    bucket: keys.s3.BUCKET,
    identityPoolId: keys.cognito.IDENTITY_POOL_ID,
  },
  API: {
    endpoints: [
      {
        name: 'tripshaAPI',
        endpoint: keys.apiGateway.URL,
        region: keys.apiGateway.REGION,
      },
    ],
  },
})

// serviceWorkerRegistration.register()
serviceWorkerRegistration.unregister()
